import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {EditorMobileOnboardingStatus, toggleOnboardingState} from '@Components/poster-editor/components/editor-mobile-onboarding/editor-mobile-onboarding.reducer';
import {AnimatePresence, motion} from 'framer-motion';
import {Tooltip, TOOLTIP_POSITION} from '@Components/tooltip';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {useAppDispatch, useAppSelector} from '@/hooks';
import styles from './canvas-zoom-pinch-onboarding.module.scss';

export function CanvasZoomPinchOnboarding(): ReactElement<any> | null {
  const onBoardingStatus = useAppSelector((state) => {
    return state.editorMobileOnboarding.onBoardingStatus;
  });
  const [showTooltip, setShowTooltip] = useState(false);
  const dispatch = useAppDispatch();

  useEffect((): void => {
    if (onBoardingStatus === EditorMobileOnboardingStatus.MOBILE_EDITOR) {
      startCanvasOnboarding();
    }
  }, [onBoardingStatus]);

  const startCanvasOnboarding = (): void => {
    setShowTooltip(true);

    setTimeout((): void => {
      setShowTooltip(false);
      dispatch(toggleOnboardingState(EditorMobileOnboardingStatus.AUTOSAVE));
    }, 2800);
  };

  return (
    <AnimatePresence>
      {showTooltip ? (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} transition={{duration: 0.1}} exit={{opacity: 0}}>
          <Tooltip
            style={{
              position: 'fixed',
              left: `calc(50% - ${294 / 2}px)`,
              bottom: `112px`,
            }}
            className={styles.tooltip}
            position={TOOLTIP_POSITION.TOP_MIDDLE}
            id="add-item-tooltip"
            text={
              <div className="flex-h-row flex-items-center">
                <Icon icon="icon-pinch" size={IconSize.SIZE_ICON_16} className={styles.pinchIcon} />
                <Text dangerouslySetInnerHTML size={TextSize.XSMALL} val={window.i18next.t('pmwjs_mobile_ux_onboarding')} />
              </div>
            }
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
